import React from 'react';
import PropTypes from 'prop-types';
import style from './realTimeVaccinationData.css';
import DescModal from './descModal';
import { formatSumData, classNames } from '../../utils/utils';

/* 实时上传数据 */
const RealTimeVaccinationData = function RealTimeVaccinationData(props) {
    const { sumData } = props;
    const { data, updateTime } = sumData;
    const chinaData = data['中国'];
    const globalData = data['全球'];

    // 渲染数字
    const sumDataRender = function sumDataRender(data) {
        const result = formatSumData(data);

        return [
            <span key="num" className={style.num}>
                {result.num === -1 ? '-' : result.num }
            </span>,
            <span key="unit" className={style.unit}>
                {result.num === -1 ? '' : `${result.unit}剂`}
            </span>,
        ];
    };

    return (
        <div className={style.box}>
            <h2 className={style.title}>实时接种数据</h2>
            <div className={classNames(style.dataBox, style.marginBottom32)}>
                <dl className={style.dataItem}>
                    <dt className={classNames(style.dataItemNum, style.color0)}>{sumDataRender(globalData.total)}</dt>
                    <dd className={classNames(style.dataItemDesc, style.bg0)}>全球累计接种</dd>
                </dl>
                <dl className={style.dataItem}>
                    <dt className={classNames(style.dataItemNum, style.color1)}>{sumDataRender(globalData.add)}</dt>
                    <dd className={classNames(style.dataItemDesc, style.bg1)}>全球较上日新增</dd>
                </dl>
                <dl className={style.dataItem}>
                    <dt className={classNames(style.dataItemNum, style.color2)}>
                        {sumDataRender(globalData.per_hundred)}
                    </dt>
                    <dd className={classNames(style.dataItemDesc, style.bg2)}>全球每百人接种</dd>
                </dl>
            </div>
            <div className={classNames(style.dataBox, style.marginBottom28)}>
                <dl className={style.dataItem}>
                    <dt className={classNames(style.dataItemNum, style.color0)}>{sumDataRender(chinaData.total)}</dt>
                    <dd className={classNames(style.dataItemDesc, style.bg0)}>中国累计接种</dd>
                </dl>
                <dl className={style.dataItem}>
                    <dt className={classNames(style.dataItemNum, style.color1)}>{sumDataRender(chinaData.add)}</dt>
                    <dd className={classNames(style.dataItemDesc, style.bg1)}>中国较上日新增</dd>
                </dl>
                <dl className={style.dataItem}>
                    <dt className={classNames(style.dataItemNum, style.color2)}>
                        {sumDataRender(chinaData.per_hundred)}
                    </dt>
                    <dd className={classNames(style.dataItemDesc, style.bg2)}>中国每百人接种</dd>
                </dl>
            </div>
            <div className={style.desc}>
                截止 {updateTime}
                <span className={style.divider}>|</span>
                数据说明
                <DescModal />
            </div>
        </div>
    );
};

RealTimeVaccinationData.propTypes = {
    sumData: PropTypes.object,
};

export default RealTimeVaccinationData;
